module.exports = __webpack_public_path__ + "static/media/googleFavicon.9a614050.svg";